import React from "react";
import { useParams } from "react-router-dom";
import ReloadCard from "../components/ReloadCard";

const ReloadTransfer = ({ typelist, getCouponTypes }) => {

    const id = useParams();
    const index = Object.values(id)[0];

    return (
        <div className="payment-container">
            <div className="card card-style pt-0" style={{background:"transparent"}}>
                <div className="content mt-3">
                    <div className="tabs tabs-pill" id="tab-group-2">
                        <ReloadCard tyid={index} typelist={typelist} getCouponTypes={getCouponTypes} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReloadTransfer;
